import React, { useState } from 'react';
import Joyride, { CallBackProps, STATUS, ACTIONS, EVENTS, Step } from 'react-joyride';

interface UserTourProps {
  run: boolean;
  onComplete: () => void;
  steps: Step[];
}

export const UserTour: React.FC<UserTourProps> = ({ run, onComplete, steps }) => {
  const [stepIndex, setStepIndex] = useState(0);

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status, action, index, type } = data;
    
    console.log('Joyride callback:', { status, action, index, type });
    
    if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
      onComplete();
      setStepIndex(0);
    } else if (type === EVENTS.STEP_AFTER || type === EVENTS.TARGET_NOT_FOUND) {
      // Update step index when moving to next/previous step
      setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
    }
  };

  // Add debug logging for initial beacon
  React.useEffect(() => {
    if (run && steps.length > 0) {
      console.log('🎯 [UserTour] Tour starting with steps:', steps);
      console.log('🎯 [UserTour] First step target:', steps[0].target);
      const firstTarget = document.querySelector(steps[0].target as string);
      console.log('🎯 [UserTour] First target element found:', firstTarget);
      if (firstTarget) {
        const rect = firstTarget.getBoundingClientRect();
        console.log('🎯 [UserTour] First target position:', rect);
      }
    }
  }, [run, steps]);

  return (
    <Joyride
      steps={steps}
      run={run}
      stepIndex={stepIndex}
      callback={handleJoyrideCallback}
      continuous
      showProgress
      showSkipButton
      disableOverlayClose
      styles={{
        options: {
          primaryColor: '#DFEF97',
          textColor: 'hsl(var(--foreground))',
          backgroundColor: 'hsl(var(--background))',
          overlayColor: 'rgba(0, 0, 0, 0.4)',
          width: 350,
        },
        tooltip: {
          borderRadius: 'var(--radius)',
          fontSize: '14px',
        },
        buttonNext: {
          backgroundColor: '#DFEF97',
          color: 'black',
          borderRadius: 'var(--radius)',
          fontSize: '14px',
          padding: '8px 16px',
        },
        buttonBack: {
          color: 'hsl(var(--muted-foreground))',
          fontSize: '14px',
        },
        buttonSkip: {
          color: 'hsl(var(--muted-foreground))',
          fontSize: '14px',
        },
      }}
    />
  );
};